import { coreAllSalesforceOrganizationsByCustomerGetSlice } from './get';

export const {
	requestGetCoreAllSalesforceOrganizationsByCustomer,
	resetGetCoreAllSalesforceOrganizationsByCustomer
} = coreAllSalesforceOrganizationsByCustomerGetSlice.asyncActionCreators;
